import { createContext } from "react";
import type { AppStatusContextValue } from "./appStatusTypes";

export const AppStatusContext = createContext<AppStatusContextValue | null>(null);
